module.exports = __webpack_public_path__ + "static/media/logo.d729204b.png";